import { render } from "./download.vue?vue&type=template&id=7651f116&scoped=true"
import script from "./download.vue?vue&type=script&lang=js"
export * from "./download.vue?vue&type=script&lang=js"

import "./download.vue?vue&type=style&index=0&id=7651f116&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7651f116"

export default script